import { Over, UniqueIdentifier } from '@dnd-kit/core';

export const isOverSection = (
  sectionId: string,
  isOver: boolean,
  over: Over | null,
  items: UniqueIdentifier[],
) => isOver || over?.data.current?.section === sectionId || !!items.find((id) => id === over?.id);
